import { render, staticRenderFns } from "./Skeletton.vue?vue&type=template&id=436dc9f4&scoped=true"
import script from "./Skeletton.vue?vue&type=script&lang=js"
export * from "./Skeletton.vue?vue&type=script&lang=js"
import style0 from "./Skeletton.vue?vue&type=style&index=0&id=436dc9f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436dc9f4",
  null
  
)

export default component.exports